export default "__VITE_ASSET__CTA6c8nr__"